import React, { Component } from "react"
import config from "react-global-configuration"
import Svg from "../../../shared/_svgs/svg"
import { getCssLegend } from "../../helpers/bookingHelper"

class ParkingCurrentBookingElement extends Component {
  renderTypeOfParking = (textKeys, carPark) => {
    switch (carPark.transfers[0].transferFrequency) {
      case "1":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
            </svg>
            {textKeys.outdoorParking || "Udendørs parkeringsanlæg"}
          </p>
        )
      case "2":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-carindoors"></use>
            </svg>
            {textKeys.indoorParking || "Indendørs parkeringsanlæg"}
          </p>
        )
      case "3":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
            </svg>
            {textKeys.in_outdoorParking || "Inden- og udendørsparkering"}
          </p>
        )
      default:
        return <div dangerouslySetInnerHTML={{ __html: `<!-- ${JSON.stringify(carPark)} -->` }} />
    }
  }

  render() {
    const { globals, changeFromBooking } = this.props
    const { product, carPark } = changeFromBooking
    const textKeys = config.get("textKeys.parkingList.listElement") || {}

    const legend = getCssLegend(carPark.name, product.name)

    let hasExtras = false
    let extrasAmount = 0
    if (changeFromBooking) {
      hasExtras = changeFromBooking.booking.items.extras.length > 0 ? true : false
      if (hasExtras) {
        extrasAmount = changeFromBooking.booking.items.extras[0].offerLines[0].amount
      }
    }

    return (
      <React.Fragment>
        <div className="parking-product-table__list__row__current">
          <div className="parking-product-table__list__row__body w--wider">
            <div className="parking-product-table__list__col parking-product-table__list__col--title">
              <div className="parking-legend__current parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${legend}`}>{carPark.name}</span>
              </div>
              <h5>{product.name}</h5>
            </div>
            <div className="parking-product-table__list__col parking-product-table__list__col--usp">
              <div className="parking-product-table__list__col--usp-distance">
                {carPark.transfers[0].transferMethodName === "Bus" ? (
                  <p>
                    <svg className="svg-icon svg-icon--bus">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-bus"></use>
                    </svg>
                    {carPark.transfers[0].transferTime} {textKeys.busTime || "min. i bus til terminalen"}
                  </p>
                ) : (
                  <p>
                    <svg className="svg-icon svg-icon--bus">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-passenger"></use>
                    </svg>
                    {carPark.transfers[0].transferTime} {textKeys.walkTime || "min. gang til terminalen"}
                  </p>
                )}
              </div>
              <div className=" parking-product-table__list__col--usp-location">
                {product.dynamicFields && product.dynamicFields.productValet ? (
                  <p>
                    <svg className="svg-icon svg-icon--sun">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-keypickup"></use>
                    </svg>
                    {textKeys.indoorDeliverOutdoorParking || "Indendørs aflevering - udendørs parkering"}
                  </p>
                ) : (
                  this.renderTypeOfParking(textKeys, carPark)
                )}
              </div>
            </div>
            {/* <div className="parking-product-table__read-more d-none--lg">
                            <button className="link js--open-modal"
                            // onClick={this.handleDetailsClick}
                            ><small>{textKeys.readMore || "Læs mere"}</small></button>
                        </div> */}

            <div className="parking-product-table__list__col parking-product-table__list__col--price">
              <div className="parking-product-table__list__col parking-product-table__list__col--banner d-none--lg">
                <span className="angled-ribbon">
                  <span className="angled-ribbon__current">
                    {/* Muligvis erstat dette med to text keys?? */}
                    <p>
                      {textKeys.ribbonLineOne || "kode"} <br /> {textKeys.ribbonLineTwo || "Booking"}
                    </p>
                  </span>
                </span>
              </div>
              <div className="parking-product-table__price-column">
                <div className="parking-product-table__prices-and-cta">
                  <div className="parking-product-table__price-details">
                    <p className="headline-xxxs">{textKeys.currentBooking || "Nuværende Booking"}</p>

                    <p className="headline-xxxs">{textKeys.alreadyPaid || "Allerede betalt"}</p>
                    <div className="parking-product-table__price-and-status">
                      <h5 className={`parking-product-table__price${product.isSoldOut ? " parking-product-table__price--soldout" : ""}`}>
                        {" "}
                        {this.props.priceFormatter(this.props.changeFromBooking.booking.price - (hasExtras ? extrasAmount : 0))}
                      </h5>
                    </div>
                  </div>

                  <div className="parking-product-table__cta">
                    <div className="parking-product-table__list__col parking-product-table__list__col--cta">
                      <button className="button button--small button--general current-booking">
                        <Svg iconName={"checkmark"} fillColor={"#FFF"} />
                        <span className="text"> {textKeys.reserved || "Reserveret"}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ParkingCurrentBookingElement
